"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _broadcastCampaign = require('shared/validation/broadcastCampaign');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _format = require('web/screens/Broadcast/format');
var _broadcastTemplate = require('shared/services/broadcastTemplate');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');

var _Form = require('web/components/Form');
var _Tabs = require('web/components/Tabs'); var _Tabs2 = _interopRequireDefault(_Tabs);
var _WizardFrame = require('../WizardFrame');
var _helpers = require('../helpers');
var _Composer = require('./Composer'); var _Composer2 = _interopRequireDefault(_Composer);
var _GateStatus = require('./GateStatus'); var _GateStatus2 = _interopRequireDefault(_GateStatus);
var _supportUrls = require('shared/data/supportUrls');
var _Preview = require('./Preview'); var _Preview2 = _interopRequireDefault(_Preview);
var _VariablesCard = require('./VariablesCard'); var _VariablesCard2 = _interopRequireDefault(_VariablesCard);
var _MissingValuesPrompt = require('./MissingValuesPrompt'); var _MissingValuesPrompt2 = _interopRequireDefault(_MissingValuesPrompt);
var _MidSendBanner = require('web/screens/Broadcast/CampaignPage/Body/MidSendBanner'); var _MidSendBanner2 = _interopRequireDefault(_MidSendBanner);
var _messageDraft = require('./messageDraft');
var _hooks3 = require('./hooks');

/* Rev 35 E1: the message or its preview, never both. */














const CampaignMessage = ({
  campaign, isCreating, onBack, onClose, onSaved,
  focusVariable = null, onDirtyChange,
}) => {
  const layout = _WizardFrame.useStepLayout.call(void 0, )
  // Rev 35 E1: the campaign page's Edit message dialog and the wizard's
  // Message step toggle Message | Preview; the dialog opens on Message with
  // the editor focused, and has no card around it.
  const isDialog = layout === 'dialog'
  // Rev 26 O2: an unsaved draft of this campaign's message comes back.
  const userKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const [draft] = _react.useState.call(void 0, () => _messageDraft.loadMessageDraft.call(void 0, userKey, campaign.CampaignKey))
  const [template, setTemplate] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([draft, 'optionalAccess', _ => _.template]), () => ( campaign.MessageTemplate)))
  /* Review R800-29: the saved message these edits started from. Another save
   * since (another tab or user) isn't overwritten until the user chooses. */
  const [savedTemplate, setSavedTemplate] = _react.useState.call(void 0, _nullishCoalesce(_optionalChain([draft, 'optionalAccess', _2 => _2.savedTemplate]), () => ( campaign.MessageTemplate)))
  const isDirty = template !== campaign.MessageTemplate
  const hasNewerSave = isDirty && savedTemplate !== campaign.MessageTemplate
  _react.useEffect.call(void 0, 
    () => { if (!isDirty) setSavedTemplate(campaign.MessageTemplate) },
    [isDirty, campaign.MessageTemplate],
  )
  _react.useEffect.call(void 0, 
    () => {
      if (isDirty) _messageDraft.saveMessageDraft.call(void 0, userKey, campaign.CampaignKey, { template, savedTemplate })
      else _messageDraft.clearMessageDraft.call(void 0, userKey, campaign.CampaignKey)
    },
    [userKey, campaign.CampaignKey, template, savedTemplate, isDirty],
  )
  _react.useEffect.call(void 0, () => { _optionalChain([onDirtyChange, 'optionalCall', _3 => _3(isDirty)]) }, [isDirty, onDirtyChange])
  const [mode, setMode] = _react.useState('message')
  const [hasOpenedPreview, setHasOpenedPreview] = _react.useState.call(void 0, isDialog)
  // The editor focuses on open in the dialog, and whenever it comes back
  // from Preview, with the caret where it was.
  const [hasToggled, setHasToggled] = _react.useState.call(void 0, false)
  const caret = _react.useRef(null)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [error, setError] = _react.useState(null)

  const messageType = campaign.MessageType 
  const limit = _broadcastCampaign.broadcastMessageLimit.call(void 0, messageType)
  const { gate, isCurrent: isGateCurrent, hasFailed: hasGateFailed } = _hooks3.useGateCheck.call(void 0, campaign.CampaignKey, template, messageType)
  const coverage = _hooks3.useVariableCoverage.call(void 0, campaign)
  const recipients = _hooks3.usePreviewRecipients.call(void 0, campaign.CampaignKey, hasOpenedPreview)

  const onChangeTemplate = _react.useCallback.call(void 0, (t) => {
    setTemplate(t)
    setError(null)
  }, [])

  const onKeepDraft = () => setSavedTemplate(campaign.MessageTemplate)
  const onUseSaved = () => {
    setTemplate(campaign.MessageTemplate)
    setError(null)
  }

  const onSelectMode = (m) => {
    setMode(m)
    setHasToggled(true)
    if (m === 'preview') setHasOpenedPreview(true)
  }

  // Rev 34 S4: a save that leaves some recipients without a value asks first
  // (from the gate over the message as it is now; a stale one doesn't ask,
  // and the send's gate still skips them).
  
  const [asking, setAsking] = _react.useState([])
  const declaredNames = _react.useMemo.call(void 0, () => campaign.TemplateFields.map(f => f.Name), [campaign.TemplateFields])
  const onRequestSave = () => {
    const missing = isGateCurrent && gate ? gate.MissingVariables.filter(m => m.Count > 0) : []
    if (missing.length) setAsking(missing)
    else onSave().catch(log.error)
  }

  const onSave = async (text = template) => {
    setIsSaving(true)
    setError(null)
    try {
      await _actions2.default.updateCampaign({
        CampaignKey: campaign.CampaignKey,
        Name: campaign.Name,
        TeamKey: campaign.TeamKey,
        SenderKey: campaign.SenderKey,
        MessageType: campaign.MessageType,
        MessageDelay: campaign.MessageDelay,
        MessageTemplate: text,
      })
      _messageDraft.clearMessageDraft.call(void 0, userKey, campaign.CampaignKey)
      onSaved()
    } catch (e) {
      setError(_helpers.errorText.call(void 0, e, "Couldn't save the message"))
      setIsSaving(false)
    }
  }

  // Missing values: the hint under the editor, and a count on Preview.
  const notice = _GateStatus.composerGateNotice.call(void 0, template, campaign.TemplateFields, gate, limit)
  const missing = _optionalChain([notice, 'optionalAccess', _4 => _4.kind]) === 'missing' ? notice : null
  const missingCount = gate ? Math.max(0, ...gate.MissingVariables.map(v => v.Count)) : 0
  const modeOptions = [
    { value: 'message', label: 'Message' },
    { value: 'preview', label: 'Preview', badge: { count: missingCount, label: 'need attention' } },
  ]

  const head = (
    _react2.default.createElement('div', { className: "broadcast-message--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}
      , _react2.default.createElement('div', { role: "group", 'aria-label': "Message or preview"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
        , _react2.default.createElement(_Tabs2.default, {
          type: "filter",
          options: modeOptions,
          value: mode,
          onSelectTab: onSelectMode,
          className: "broadcast-message--modes", __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
        )
      )
      ,  mode === 'message' && (
        _react2.default.createElement(_GateStatus2.default, {
          template: template,
          fields: campaign.TemplateFields,
          gate: gate,
          limit: limit,
          isCurrent: isGateCurrent,
          hasFailed: hasGateFailed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}
        )
      )
      , _react2.default.createElement('div', { className: "broadcast-wizard--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} )
      , _react2.default.createElement('a', {
        href: _supportUrls.broadcastDocsUrl,
        target: "_blank",
        rel: "noreferrer",
        className: "broadcast-learn-more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}

        , _react2.default.createElement('span', { className: "broadcast-learn-more--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}, "?"), "Learn more"

      )
    )
  )
  const newerSave = hasNewerSave && (
    _react2.default.createElement('div', { role: "alert", className: "broadcast-banner broadcast-banner--warn broadcast-message--newer-save"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
      , _react2.default.createElement('span', { className: "broadcast-banner--icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}, "!")
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}, "This message was changed and saved after you started your draft."          ), ' ', "Your draft is below. The saved message reads:"

        , _react2.default.createElement('blockquote', { className: "broadcast-message--saved-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}},  campaign.MessageTemplate )
        , _react2.default.createElement('div', { className: "broadcast-message--newer-save-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 186}}
          , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onUseSaved, __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}, "Use saved message"  )
          , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: onKeepDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}, "Keep my draft"  )
        )
      )
    )
  )
  const missingHint = missing && (
    _react2.default.createElement('p', { className: "broadcast-message--missing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}
      , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 195}}, "! " )
      ,  _format.pluralize.call(void 0, missing.count, 'recipient has', 'recipients have') , " no" , ' '
      ,  _broadcastTemplate.isBuiltInVariable.call(void 0, missing.name) ? _broadcastTemplate.builtInLabel.call(void 0, missing.name) : missing.name , ". Click it in the message to give it a "
           ,  _broadcastTemplate.isBuiltInVariable.call(void 0, missing.name) ? 'fallback' : 'default' , ", or" , ' '
      , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", onClick: () => onSelectMode('preview'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}, "see them in Preview"

      ), "."
    )
  )
  const messageMode = (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  newerSave 
      /* Rev 32 V2: the notice is the dialog's, never the wizard's. */
      ,  isDialog && _react2.default.createElement(_MidSendBanner2.default, { campaignKey: campaign.CampaignKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}} ) 
      , _react2.default.createElement(_Composer2.default, {
        template: template,
        onChangeTemplate: onChangeTemplate,
        fields: campaign.TemplateFields,
        coverage: coverage,
        messageType: messageType,
        limit: limit,
        gate: gate,
        focusVariable: hasToggled ? null : focusVariable,
        isFocusedOnOpen: isDialog || hasToggled,
        caret: caret,
        footnote: missingHint, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
      )
    )
  )
  const previewMode = (
    _react2.default.createElement(_Preview2.default, {
      campaign: campaign,
      template: template,
      recipients: recipients,
      notice: hasNewerSave && (
        _react2.default.createElement('p', { role: "alert", className: "broadcast-message--elsewhere", __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}, "This message was changed elsewhere. Go to Message to choose."

        )
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 225}}
    )
  )
  const errorNote = error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}},  error )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  isDialog
        ? (
            _react2.default.createElement(_WizardFrame.StepBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}
              ,  head 
              , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'broadcast-message-dialog--mode', `broadcast-message-dialog--${mode}`), __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}
                ,  mode === 'message' ? messageMode : previewMode 
              )
              ,  errorNote 
            )
          )
        : (
            _react2.default.createElement(_WizardFrame.StepBody, { isWide: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
              , _react2.default.createElement('div', { className: "broadcast-wizard--card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}
                , _react2.default.createElement('div', { className: "broadcast-wizard--card-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}},  head )
                , _react2.default.createElement('div', { className: "broadcast-wizard--card-pad", __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}
                  ,  mode === 'message' ? messageMode : previewMode 
                  ,  errorNote 
                )
              )
              ,  mode === 'message' && layout === 'wizard' && campaign.TemplateFields.length > 0 && (
                _react2.default.createElement(_VariablesCard2.default, { template: template, coverage: coverage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}} )
              )
            )
          )
      
      , _react2.default.createElement(_WizardFrame.StepFooter, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
        , _react2.default.createElement(_Form.Button, { isSecondary: true, onClick: isCreating ? onBack : onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
          ,  isCreating ? 'Back' : 'Cancel' 
        )
        , _react2.default.createElement('div', { className: "broadcast-wizard--foot-grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}} )
        ,  !isCreating && isDirty && (
          _react2.default.createElement('span', { className: "broadcast-unsaved", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 271}}, "Unsaved changes" )
        )
        , _react2.default.createElement(_Form.Button, {
          isLoading: isSaving,
          isDisabled: isSaving || !template.trim() || hasNewerSave,
          onClick: onRequestSave, __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}

          ,  isCreating ? 'Save campaign' : 'Save message' 
        )
      )
      , _react2.default.createElement(_MissingValuesPrompt2.default, {
        campaignKey: campaign.CampaignKey,
        missing: asking,
        declared: declaredNames,
        onClose: () => setAsking([]),
        onSave: (fallbacks = {}) => {
          setAsking([])
          // Rev 35 E4: a name's fallback goes into the message's tokens.
          const text = Object.entries(fallbacks).reduce((t, [name, fallback]) => _broadcastTemplateTokens.addFallback.call(void 0, t, name, fallback), template)
          if (text !== template) setTemplate(text)
          onSave(text).catch(log.error)
        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, CampaignMessage)
